export default __webpack_public_path__ + "7a4ceb77edbc6e6cd12e3c2c06b6b808.png";